import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../../ui/card';
import { CreditSubmission } from '../../../../api/creditSubmissionApi';
import { formatDate } from './utils';

interface DetailMetadataProps {
  submission: CreditSubmission;
}

export default function DetailMetadata({ submission }: DetailMetadataProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Informasi Sistem</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-2 gap-4 text-sm">
          <div>
            <label className="text-gray-600">Dibuat pada</label>
            <p className="font-medium mt-1">{formatDate(submission.created_at)}</p>
          </div>
          <div>
            <label className="text-gray-600">Diperbarui pada</label>
            <p className="font-medium mt-1">{formatDate(submission.updated_at)}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
